require('./insurancesProfileDocumentationRow.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
// @ helpers
const { FormattedText } = require('core/i18n').i18n;

// @ commons
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');

// @ components
const InsurancesProfileDocumentationRow = require('./insurancesProfileDocumentationRow');

// @ constants
class InsurancesProfileDocumentation extends React.Component {

    buildColumnTitles() {
        const insuranceTypeCol = this.buildInsuranceTypeCol();
        const documentationTypeCol = this.buildDocumentationTypeCol()
        return (
            <thead>
                <OKTableRow asHeader={true}>
                    <OKTableCell className="insurances-profile-documentation__date" asHeader={true}>
                        <FormattedText value="profileDocumentation-documentationDate" />
                    </OKTableCell>
                    {insuranceTypeCol}
                    {documentationTypeCol}
                    <OKTableCell className="insurances-profile-documentation__right-action" asHeader={true} />
                </OKTableRow>
            </thead>
        );
    }

    buildDocumentationTypeCol() {
        return (
            <OKTableCell asHeader={true}>
                <FormattedText value="profileDocumentation-documentationType" />
            </OKTableCell>
        );
    }

    buildInsuranceTypeCol() {
        return (
            <OKTableCell asHeader={true}>
                <FormattedText value="profileDocumentation-insuranceType" />
            </OKTableCell>
        );
    }

    buildTableContent(data) {
        let response;
        const {
            callbackDownloadFile,
            maxDocumentsToSee,
            documentDownloadingPolicyNumber,
            documentsFetch
        } = this.props;
        const createItems = (immDocument, indexContractedDocument) => {
            const date = immDocument.get('generationDate');
            const row = (
                <InsurancesProfileDocumentationRow
                    callbackDownloadFile={callbackDownloadFile}
                    date={date}
                    insuranceTypeName={immDocument.get('insuranceTypeName')}
                    policyCode={immDocument.get('policyCode')}
                    documentDesc={immDocument.get('documentDesc')}
                    key={indexContractedDocument}
                    documentDownloadingPolicyNumber={documentDownloadingPolicyNumber}
                    documentsFetch={documentsFetch}
                />
            );

            if (maxDocumentsToSee < 0) {
                return row;
            } else if (indexContractedDocument + 1 <= maxDocumentsToSee) {
                return row;
            }
        };

        if (data && data.size) {
            let wrappedData = data;

            response = (
                <tbody>
                    {wrappedData.map(createItems)}
                </tbody>
            );

            return response;
        }
    }

    render() {
        const { data, hideTableHeader } = this.props;
        let columnTitles = !hideTableHeader && this.buildColumnTitles();
        return (
            <OKTable>
                {columnTitles}
                {this.buildTableContent(data)}
            </OKTable>
        )
    }
}

InsurancesProfileDocumentation.propTypes = {
    callbackDownloadFile: PropTypes.func,
    currentDocument: PropTypes.bool,
    data: PropTypes.object,
    maxDocumentsToSee: PropTypes.number,
    hideTableHeader: PropTypes.bool,
    documentDownloadingPolicyNumber: PropTypes.string,
    documentsFetch: PropTypes.object,
};

InsurancesProfileDocumentation.defaultProps = {
    currentDocument: false,
    data: {},
    maxDocumentsToSee: -1,
    hideTableHeader: false
};

module.exports = InsurancesProfileDocumentation;
